import React from 'react';

const INK   = '#2B2620';
const OCHRE = '#A6752A';
const MOSS  = '#3B6B44';
const STONE = '#8C8275';
const PAPER = '#FDFBF8';
const FONT_SANS = "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

export default function TrendChart({ soldData = [], completedData = [], months = [] }) {
  const maxValue = Math.max(
    ...soldData,
    ...completedData,
    1
  );

  const chartHeight = 200;

  return (
    <div style={{
      padding: '20px',
      background: PAPER,
      borderRadius: '14px',
      border: '1px solid rgba(139,69,19,0.1)',
      boxShadow: '0 2px 12px rgba(139,69,19,0.06)',
      fontFamily: FONT_SANS,
    }}>
      <h3 style={{
        fontSize: '15px',
        fontWeight: '600',
        color: INK,
        marginBottom: '20px'
      }}>
        Sold vs Completed Trend
      </h3>

      {/* Legend */}
      <div style={{
        display: 'flex',
        gap: '20px',
        marginBottom: '20px'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }}>
          <div style={{
            width: '10px',
            height: '10px',
            background: OCHRE,
            borderRadius: '3px'
          }} />
          <span style={{ fontSize: '12px', color: STONE, fontWeight: '600' }}>
            Sold
          </span>
        </div>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }}>
          <div style={{
            width: '10px',
            height: '10px',
            background: MOSS,
            borderRadius: '3px'
          }} />
          <span style={{ fontSize: '12px', color: STONE, fontWeight: '600' }}>
            Completed
          </span>
        </div>
      </div>

      {/* Chart Area */}
      <div style={{
        position: 'relative',
        height: `${chartHeight}px`,
        background: 'rgba(139,69,19,0.03)',
        borderRadius: '8px',
        padding: '10px'
      }}>
        {months.length === 0 ? (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            color: STONE,
            fontSize: '13px'
          }}>
            No data available
          </div>
        ) : (
          <div style={{
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'space-around',
            height: '100%',
            gap: '4px'
          }}>
            {months.map((month, index) => {
              const soldHeight = maxValue > 0 ? (soldData[index] / maxValue) * 100 : 0;
              const completedHeight = maxValue > 0 ? (completedData[index] / maxValue) * 100 : 0;

              return (
                <div
                  key={index}
                  style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '4px'
                  }}
                >
                  {/* Bars Container */}
                  <div style={{
                    flex: 1,
                    width: '100%',
                    display: 'flex',
                    gap: '2px',
                    alignItems: 'flex-end'
                  }}>
                    {/* Sold Bar */}
                    <div
                      style={{
                        flex: 1,
                        height: `${soldHeight}%`,
                        minHeight: soldData[index] > 0 ? '4px' : '0',
                        background: OCHRE,
                        borderRadius: '4px 4px 0 0',
                        transition: 'height 0.5s ease',
                        position: 'relative'
                      }}
                      title={`Sold: ${soldData[index]}`}
                    >
                      {soldData[index] > 0 && (
                        <div style={{
                          position: 'absolute',
                          top: '-18px',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          fontSize: '10px',
                          fontWeight: '700',
                          color: OCHRE,
                          whiteSpace: 'nowrap'
                        }}>
                          {soldData[index]}
                        </div>
                      )}
                    </div>

                    {/* Completed Bar */}
                    <div
                      style={{
                        flex: 1,
                        height: `${completedHeight}%`,
                        minHeight: completedData[index] > 0 ? '4px' : '0',
                        background: MOSS,
                        borderRadius: '4px 4px 0 0',
                        transition: 'height 0.5s ease',
                        position: 'relative'
                      }}
                      title={`Completed: ${completedData[index]}`}
                    >
                      {completedData[index] > 0 && (
                        <div style={{
                          position: 'absolute',
                          top: '-18px',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          fontSize: '10px',
                          fontWeight: '700',
                          color: MOSS,
                          whiteSpace: 'nowrap'
                        }}>
                          {completedData[index]}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Month Label */}
                  <div style={{
                    fontSize: '11px',
                    fontWeight: '600',
                    color: STONE,
                    textAlign: 'center'
                  }}>
                    {month}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
